import Box from "@mui/material/Box";
import { useTranslationApp } from "../../../lib/i18next";
import Button from "../../../components/Buttons/Button";
import { BUTTON_VIEW_DETAILS, PAY } from "../../../i18n/keysTranslations";

const ActionsInvoicesTable = ({
  data,
  onSelectInvoice,
  onPayInvoice,
  keyInvoice,
  payLoading = false,
}) => {
  const { t } = useTranslationApp();
  return (
    <Box
      sx={{
        display: { xs: "inline", lg: "flex" },
        gap: 2,
        justifyContent: "flex-start",
      }}
    >
      <Button
        variant="contained"
        color="secondary"
        sx={{
          minWidth: 115,
          maxWidth: 140,
        }}
        onClick={() => onSelectInvoice(keyInvoice)}
        fullWidth={true}
      >
        {t(BUTTON_VIEW_DETAILS)}
      </Button>
      {!data.isPaid && !data.params.orderIDs && !data.paymentLink && (
        <Button
          color="secondary"
          loading={payLoading}
          onClick={() => onPayInvoice(keyInvoice)}
          fullWidth
          sx={{
            minWidth: 130,
            maxWidth: "fit-content",
          }}
        >
          {t(PAY)}
        </Button>
      )}
    </Box>
  );
};

export default ActionsInvoicesTable;
